import OneModal from "../OneModal/OneModal"
import { Unstable_Grid2 as Grid } from "@mui/material"
import ModalBody from "./ModalBody"

const ModalFecharEventos = ({ open = false, setOpen }) => {
    return (
        <>
            <OneModal
                open={open}
                setOpen={setOpen}
                titleText={"Fechar eventos em massa"}
                maxWidth='lg'
                fullWidth={false}
            >
                <Grid container xs={12} sx={{ gap: '20px', width: '900px' }}>
                    <ModalBody setOpenModal={setOpen} />
                </Grid>
            </OneModal>
        </>
    )
}

export default ModalFecharEventos
